import useSession from 'data/firestore/session/use';
import { Session } from 'data/firestore/session/types';
import useHttpQuery from 'data/firestore/useHttpQuery';
import { SessionCustomer } from 'data/firestore/globals';
import useCustomer from 'data/firestore/agent/customer/use';

const getCustomer = ({
    sessionCustomer,
    customer,
    resolvedCustomer,
}:{
    sessionCustomer?: SessionCustomer | null,
    customer?: SessionCustomer | null,
    resolvedCustomer?: SessionCustomer | null,
}) => {
    if (resolvedCustomer) return resolvedCustomer;
    if (customer) {
        return {
            ...(sessionCustomer || {}),
            displayName: customer.displayName,
            firstName: customer.firstName,
            lastName: customer.lastName,
            alias: customer.alias,
            photoURL: customer.photoURL,
        } as SessionCustomer;
    }
    return sessionCustomer;
};

const useSessionCustomer = (
    session?: Session | string,
    options: { disabled: boolean } = { disabled: false },
) => {
    const sessionId = typeof session === 'string' ? session : session?.id as string;
    const { data } = useSession(sessionId, {
        disabled: typeof session !== 'string' || !sessionId,
    });
    const sessionData = typeof session === 'string' ? data : session;

    const sessionCustomer = sessionData?.customer;

    const { data: customer, isLoading: isLoadingCustomer } = useCustomer(
        sessionData?.agentId as string,
        sessionCustomer?.id as string,
        {
            disabled: !sessionCustomer?.id || !sessionData?.agentId,
        },
    );

    const { data: sessionWithCustomer, isLoading } = useHttpQuery<Session>({
        key: ['session', sessionId],
        pathname: `/agents/${sessionData?.agentId}/calls/${sessionId}`,
        queryOptions: {
            enabled: !sessionCustomer?.id && !!sessionData?.agentId && !options.disabled,
        },
    });

    return {
        isLoading: sessionCustomer?.id ? isLoadingCustomer : isLoading,
        customer: getCustomer({
            sessionCustomer,
            customer: customer as SessionCustomer,
            resolvedCustomer: sessionWithCustomer?.customer as SessionCustomer,
        }) as SessionCustomer,
    };
};

export default useSessionCustomer;
